import { render, staticRenderFns } from "./g-assistant-composer.vue?vue&type=template&id=4c300546&scoped=true&"
import script from "./g-assistant-composer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-assistant-composer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-assistant-composer.vue?vue&type=style&index=0&id=4c300546&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c300546",
  null
  
)

export default component.exports